import { useSearchParams } from "react-router-dom";
import { Page } from "../../../types/GlobalInterfaces";
import { View } from "../../../types/PageInterfaces";
import PageViewFlowChartList from "./PageViewFlowChartList";
import PageViewFlowChart from "./PageViewFlowChart";

interface Props {
  page: Page;
  view: View;
  viewLoading: boolean;
}

export default function PageViewFlowRenderer(props: Props) {
  const [params] = useSearchParams();

  const flowID = params.get("flow");

  if (flowID) {
    return (
      <PageViewFlowChart
        {...props}
        chartName={props.view?.Name}
        loading={props.viewLoading}
      />
    );
  }

  return <PageViewFlowChartList {...props} />;
}
